console.log("Pokemon Grid Adapter loaded");

(function (window, document) {
  "use strict";

  var isSearchPage = Boolean(
    window.PokemonSearchConfig
  );

  var config = isSearchPage
    ? (window.PokemonSearchConfig || {})
    : (window.PokemonCollectionConfig || {});

  var INSTANCE_ID = isSearchPage
    ? "pokemon-search"
    : "pokemon-collection";

  var FORM_ID = "W2nZC4";
  var registeredInstance = null;
  var collectionNavigation = null;

  function normalizeText(value) {
    return String(
      value == null ? "" : value
    ).trim();
  }

  function normalizeLower(value) {
    return normalizeText(value).toLowerCase();
  }

  function escapeRegExp(value) {
    return String(value || "")
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function normalizeCollectorNumber(value) {
    return normalizeText(value)
      .split("/")
      .map(function (part) {
        var cleaned = part.replace(
          /^0+(?=\d)/,
          ""
        );

        return cleaned || "0";
      })
      .join("/");
  }

    function normalizePokemonTitleDetail(
    value
  ) {
    return normalizeLower(value)
      .replace(/[-–—]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function cleanPokemonTitleDetails(
    value
  ) {
    /*
      Generic finish names already receive their own
      finish badge, so don't repeat them as title extras.

      Specific treatments such as:
        Cosmo Holofoil
        Galaxy Holofoil
        Gamestop Exclusive

      remain visible.
    */
    var genericFinishDetails = [
      "normal",
      "nonfoil",
      "non foil",
      "foil",
      "holo",
      "holofoil",
      "reverse holo",
      "reverse holofoil",
      "reverse foil"
    ];

    return normalizeText(value)
      .split(",")
      .map(function (part) {
        return normalizeText(part);
      })
      .filter(Boolean)
      .filter(function (part) {
        return (
          genericFinishDetails.indexOf(
            normalizePokemonTitleDetail(
              part
            )
          ) === -1
        );
      })
      .join(" · ");
  }

  function getPokemonTitleParts(variant) {
    var title = normalizeText(
      variant && variant.title
    );

    var cardNumber = normalizeText(
      variant && variant.number
    );

    var details = "";

    if (!title) {
      return {
        name: "",
        details: ""
      };
    }

    /*
      Product titles may end with a treatment/detail
      group in parentheses. Keep that out of the main
      visible card name.
    */
    var detailsMatch = title.match(
      /^(.*?)\s*\(([^()]*)\)\s*$/
    );

    if (detailsMatch) {
      title = normalizeText(
        detailsMatch[1]
      );

      details = cleanPokemonTitleDetails(
        detailsMatch[2]
      );
    }

    /*
      Remove a collector number when it is duplicated at
      the end of the Shopify title.
    */
    if (cardNumber) {
      var numberCandidates = [
        cardNumber,
        normalizeCollectorNumber(
          cardNumber
        )
      ].filter(function (
        value,
        index,
        values
      ) {
        return (
          value &&
          values.indexOf(value) === index
        );
      });

      numberCandidates.forEach(
        function (numberValue) {
          title = title.replace(
            new RegExp(
              "\\s+" +
              escapeRegExp(numberValue) +
              "$",
              "i"
            ),
            ""
          ).trim();
        }
      );
    }

    return {
      name: title,
      details: details
    };
  }

  function normalizePokemonFinish(value) {
    var finish = normalizeLower(value)
      .replace(/[-–—]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (!finish) {
      return "";
    }

    if (
      finish === "normal" ||
      finish === "nonfoil" ||
      finish === "non foil"
    ) {
      return "Normal";
    }

    if (
      finish.indexOf("reverse holo") !== -1 ||
      finish.indexOf("reverse foil") !== -1
    ) {
      return "Reverse Holofoil";
    }

    if (
      finish === "holo" ||
      finish === "holofoil" ||
      finish === "foil" ||
      finish.indexOf("holofoil") !== -1
    ) {
      return "Holofoil";
    }

    return normalizeText(value);
  }

  function normalizePokemonSupertype(value) {
    var supertype = normalizeLower(value);

    if (supertype === "pokemon") {
      return "Pokémon";
    }

    if (supertype === "pokémon") {
      return "Pokémon";
    }

    if (supertype === "trainer") {
      return "Trainer";
    }

    if (supertype === "energy") {
      return "Energy";
    }

    return normalizeText(value);
  }

  function getFinishClass(value) {
    return normalizeLower(value)
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function isFoilFinish(value) {
    var finish = normalizePokemonFinish(
      value
    );

    return Boolean(
      finish && finish !== "Normal"
    );
  }

  function formatHp(value) {
    var hp = normalizeText(value);

    if (!hp) {
      return "";
    }

    return /\bhp\b/i.test(hp)
      ? hp
      : hp + " HP";
  }

  function joinListDetails(
    values,
    escapeHtml
  ) {
    return values
      .filter(Boolean)
      .map(function (value) {
        return escapeHtml(value);
      })
      .join(
        "<span" +
          " class=\"singles-list-detail-divider\"" +
          " aria-hidden=\"true\"" +
        "> • </span>"
      );
  }

  function registerPokemonGrid() {
    if (registeredInstance) {
      return registeredInstance;
    }

    if (
      !window.SinglesGrid ||
      !window.SinglesGrid.version
    ) {
      return null;
    }

    var api = window.SinglesGrid;
    var helpers = api.helpers;
    var escapeHtml = helpers.escapeHtml;
    var escapeAttribute =
      helpers.escapeAttribute;

        function getCurrentSetSymbolUrl(
          variant
        ) {
          /*
            Prefer a symbol URL supplied directly
            by the card/search JSON.
          */
          var rowSymbolUrl =
            normalizeText(
              variant &&
              (
                variant.set_symbol_url ||
                variant.setSymbolUrl ||
                variant.symbol_url ||
                variant.symbolUrl
              )
            );

          if (rowSymbolUrl) {
            return rowSymbolUrl;
          }

          /*
            A search page may provide a lookup table
            keyed by set code.
          */
          var setCode =
            normalizeText(
              variant &&
              (
                variant.set_code ||
                variant.setCode
              )
            );

          if (
            setCode &&
            config.setSymbolUrls
          ) {
            var mappedSymbol =
              config.setSymbolUrls[setCode] ||
              config.setSymbolUrls[
                setCode.toLowerCase()
              ] ||
              config.setSymbolUrls[
                setCode.toUpperCase()
              ];

            if (mappedSymbol) {
              return normalizeText(
                mappedSymbol
              );
            }
          }

          /*
            Collection pages can use their current
            set header image.
          */
          var root =
            registeredInstance &&
            registeredInstance.root;

          if (root) {
            var headerImage =
              root.querySelector(
                ".pokemon-set-header-image"
              );

            if (headerImage) {
              var headerUrl =
                normalizeText(
                  headerImage.currentSrc ||
                  headerImage.getAttribute(
                    "src"
                  )
                );

              if (headerUrl) {
                return headerUrl;
              }
            }
          }

          /*
            Final configured collection fallback.
          */
          return normalizeText(
            config.setSymbolUrl
          );
        }


        function renderSetSymbol(
          variant
        ) {
          var setSymbolUrl =
            getCurrentSetSymbolUrl(
              variant
            );

      if (setSymbolUrl) {
        return (
          "<img" +
            " class=\"pokemon-card-set-symbol\"" +
            " src=\"" +
              escapeAttribute(
                setSymbolUrl
              ) +
            "\"" +
            " alt=\"\"" +
            " aria-hidden=\"true\"" +
            " loading=\"lazy\"" +
            " decoding=\"async\"" +
          ">"
        );
      }

      return (
        "<span" +
          " class=\"tcg-pokeball-icon\"" +
          " aria-hidden=\"true\"" +
        "></span>"
      );
    }

    function renderFinishBadge(
      variant,
      mode
    ) {
      var finish = normalizePokemonFinish(
        variant && variant.finish
      );

      if (!finish || finish === "Normal") {
        return "";
      }

      return api.render.finishBadge(
        {
          text: finish,
          cls:
            "badge-regular finish-" +
            getFinishClass(finish)
        },
        {
          mode: mode,
          className:
            "pokemon-finish-badge"
        }
      );
    }

        function renderGridMetadata(
          variant,
          titleParts
        ) {
          var details = [];

          var number =
            normalizeCollectorNumber(
              variant && variant.number
            );

          if (number) {
            details.push(number);
          }

          if (
            titleParts &&
            titleParts.details
          ) {
            details.push(
              titleParts.details
            );
          }

          return api.render.gridTitleDetails(
            details.join(" · ")
          );
        }

    function renderGridSet(variant) {
      var setName = normalizeText(
        variant && variant.set_name
      );

      if (!setName) {
        return "";
      }

      return (
        "<div" +
          " class=\"singles-grid-set pokemon-grid-set\"" +
          " data-pokemon-set-row" +
        ">" +
          renderSetSymbol(
            variant
          ) +
          "<span data-pokemon-set-name>" +
            escapeHtml(setName) +
          "</span>" +
        "</div>"
      );
    }

    function renderListSet(variant) {
      var setName = normalizeText(
        variant && variant.set_name
      );

      if (!setName) {
        return "";
      }

      return (
        renderSetSymbol(
          variant
        ) +
        "<span data-pokemon-list-set-name>" +
          escapeHtml(setName) +
        "</span>"
      );
    }

    function renderListMetadata(variant) {
      var typeDetails = [];
      var propertyDetails = [];

      var supertype =
        normalizePokemonSupertype(
          variant && variant.supertypes
        );

      var stage = normalizeText(
        variant && variant.stage
      );

      var rarity = normalizeText(
        variant && variant.rarity
      );

      var hp = formatHp(
        variant && variant.life
      );

      if (supertype) {
        typeDetails.push(supertype);
      }

      if (stage) {
        typeDetails.push(stage);
      }

      if (rarity) {
        propertyDetails.push(rarity);
      }

      if (hp) {
        propertyDetails.push(hp);
      }

      var html = "";

      if (typeDetails.length) {
        html +=
          "<div" +
            " class=\"singles-list-type-line\"" +
            " data-pokemon-list-type-line" +
          ">" +
            joinListDetails(
              typeDetails,
              escapeHtml
            ) +
          "</div>";
      }

      if (propertyDetails.length) {
        html +=
          "<div" +
            " class=\"singles-list-properties\"" +
            " data-pokemon-list-properties" +
          ">" +
            joinListDetails(
              propertyDetails,
              escapeHtml
            ) +
          "</div>";
      }

      return html;
    }  

      function renderPokemonGridCard(
      card,
      selected,
      instance
    ) {
      var titleParts =
        getPokemonTitleParts(selected);

      var productUrl = normalizeText(
        selected.product_url
      ) || (
        "/products/" +
        encodeURIComponent(card.key)
      );

      return api.render.gridCard(
        card,
        selected,
        instance,
        {
          title: titleParts.name,
          titleClass:
            "pokemon-grid-title",

          productUrl: productUrl,

          imageUrl:
            selected.img_url,

          imageAlt:
            selected.title ||
            titleParts.name,

          isFoil:
            isFoilFinish(
              selected.finish
            ),

          titleExtraHtml:
            renderGridMetadata(
              selected,
              titleParts
            ),

          finishBadgeHtml:
            renderFinishBadge(
              selected,
              "grid"
            ),

          setRowHtml:
            renderGridSet(
              selected
            ),

          formId: FORM_ID
        }
      );
    }


    function renderPokemonListCard(
      card,
      selected,
      instance
    ) {
      var titleParts =
        getPokemonTitleParts(selected);

      var productUrl = normalizeText(
        selected.product_url
      ) || (
        "/products/" +
        encodeURIComponent(card.key)
      );

      var collectorNumber =
        normalizeCollectorNumber(
          selected.number
        );

            var titleDetailValues = [];

            if (collectorNumber) {
              titleDetailValues.push(
                collectorNumber
              );
            }

            if (titleParts.details) {
              titleDetailValues.push(
                titleParts.details
              );
            }

            var titleDetailsHtml =
              joinListDetails(
                titleDetailValues,
                escapeHtml
              );

      return api.render.listCard(
        card,
        selected,
        instance,
        {
          title:
            titleParts.name,

          productUrl:
            productUrl,

          imageUrl:
            selected.img_url,

          imageAlt:
            selected.title ||
            titleParts.name,

          isFoil:
            isFoilFinish(
              selected.finish
            ),

          finishBadgeHtml:
            renderFinishBadge(
              selected,
              "list"
            ),

          titleDetailsHtml:
            titleDetailsHtml,

          setHtml:
            renderListSet(
              selected
            ),

          metadataHtml:
            renderListMetadata(
              selected
            ),

          formId:
            FORM_ID
        }
      );
    }


    function updatePokemonCardVariant(
      cardElement,
      card,
      variant,
      instance
    ) {
      /*
        List view only needs the shared selected-variant
        areas replaced.

        Pokémon identity information does not change
        between condition variants of the same product.
      */
      if (
        cardElement.hasAttribute(
          "data-singles-list-card"
        )
      ) {
        api.render.updateListCardVariant(
          cardElement,
          variant,
          {
            formId: FORM_ID
          }
        );

        return;
      }

      /*
        Grid view uses the equivalent shared updater.
      */
      api.render.updateGridCardVariant(
        cardElement,
        variant,
        {
          formId: FORM_ID
        }
      );
    }


    function renderEnergyTypeOption(
      value,
      active
    ) {
      var energyType =
        normalizeText(value);

      var iconUrl =
        config.energyIconUrls &&
        config.energyIconUrls[
          energyType
        ];

      var html = "";

      html +=
        "<button" +
          " type=\"button\"" +
          " class=\"singles-filter-chip pokemon-energy-filter" +
            (
              active
                ? " active"
                : ""
            ) +
          "\"" +
          " data-singles-filter-key=\"energy_type\"" +
          " data-singles-filter-value=\"" +
            escapeAttribute(
              energyType
            ) +
          "\"" +
          " aria-pressed=\"" +
            (
              active
                ? "true"
                : "false"
            ) +
          "\"" +
        ">";

      if (iconUrl) {
        html +=
          "<img" +
            " class=\"pokemon-energy-filter-icon\"" +
            " src=\"" +
              escapeAttribute(
                iconUrl
              ) +
            "\"" +
            " alt=\"\"" +
            " aria-hidden=\"true\"" +
          ">";
      }

      html +=
        "<span" +
          " class=\"pokemon-energy-filter-label\"" +
        ">" +
          escapeHtml(
            energyType
          ) +
        "</span>";

      html += "</button>";

      return html;
    } 

    function renderRarityOption(
      value,
      active
    ) {
      var rarityValue =
        normalizeText(value);

      var displayLabel =
        rarityValue.toLowerCase() ===
        "mega hyper rare"
          ? "Hyper Rare"
          : rarityValue;

      return (
        "<button" +
          " type=\"button\"" +
          " class=\"singles-filter-chip" +
            (
              active
                ? " active"
                : ""
            ) +
          "\"" +

          " data-singles-filter-key=\"rarity\"" +

          " data-singles-filter-value=\"" +
            escapeAttribute(
              rarityValue
            ) +
          "\"" +

          " aria-pressed=\"" +
            (
              active
                ? "true"
                : "false"
            ) +
          "\"" +
        ">" +

          "<span" +
            " class=\"pokemon-rarity-filter-label\"" +
          ">" +
            escapeHtml(
              displayLabel
            ) +
          "</span>" +

        "</button>"
      );
    }
    
      registeredInstance = api.create({
      id: INSTANCE_ID,
      game: "pokemon",

      rowsElementId:
        isSearchPage
          ? "singles-search-cardjson"
          : "",

      storageNamespace:
        isSearchPage
          ? "pokemonSearch"
          : "pokemon",

      root:
        config.root ||
        (
          isSearchPage
            ? "[data-singles-search-results][data-game=\"pokemon\"]"
            : "[data-singles-collection][data-game=\"pokemon\"]"
        ),

      grid:
        "[data-singles-grid]",

      loading:
        "[data-singles-grid-loading]",

      jsonUrl:
        isSearchPage
          ? ""
          : config.jsonUrl,

      productCount:
        isSearchPage
          ? 0
          : config.productCount,

      /*
        Collection pages load through the shared
        collection JSON loader.

        Search pages already receive embedded rows,
        so they are installed separately later.
      */
      autoLoad:
        !isSearchPage,

      defaultAvailability:
        config.defaultAvailability ||
        (
          isSearchPage
            ? "all"
            : "instock"
        ),

      /*
        Search may remember All / In Stock.

        Collection pages reset to In Stock on a
        normal page load, matching the MTG behavior.
      */
      persistAvailability:
        isSearchPage,

      clearAvailability:
        "all",

      defaultView:
        config.defaultView ||
        "grid",

      defaultSort:
        config.defaultSort ||
        (
          isSearchPage
            ? "best-selling"
            : "manual"
        ),

      stockFirstWhenAll:
        isSearchPage,

      sortRenderDelay:
        isSearchPage
          ? 50
          : 0,

      allowedSorts: [
        "manual",
        "best-selling",
        "title-ascending",
        "price-ascending",
        "price-descending"
      ],

      syncSortToUrl:
        true,

      emptyMessage:
        "No matching Pokémon cards were found.",

      errorHeading:
        "Pokémon cards could not be loaded.",

      filterDefinitions: [

        /* ======================================================
           FINISH
        ====================================================== */

        {
          key: "finish",
          label: "Finish",
          split: false,

          options: [
            "Normal",
            "Holofoil",
            "Reverse Holofoil"
          ],

          /*
            Shopify's stored finish vocabulary can vary,
            so normalize the actual card values before
            the shared filter engine compares them.
          */
          getValues: function (card) {
            var values = [];

            card.variants.forEach(
              function (variant) {
                var finish =
                  normalizePokemonFinish(
                    variant.finish
                  );

                if (finish) {
                  values.push(finish);
                }
              }
            );

            return values;
          }
        },


        /* ======================================================
           CARD CATEGORY
        ====================================================== */

        {
          key: "supertype",
          label: "Card Category",

          options: [
            "Pokémon",
            "Trainer",
            "Energy"
          ],

          getValues: function (card) {
            var values = [];

            card.variants.forEach(
              function (variant) {
                normalizeText(
                  variant.supertypes
                )
                  .split(/,\s*/)
                  .forEach(
                    function (value) {
                      var normalized =
                        normalizePokemonSupertype(
                          value
                        );

                      if (normalized) {
                        values.push(
                          normalized
                        );
                      }
                    }
                  );
              }
            );

            return values;
          }
        },


        /* ======================================================
           ENERGY TYPE
        ====================================================== */

        {
          key: "energy_type",
          field: "types",
          label: "Energy Type",

          separator:
            /,\s*/,

          options: [
            "Grass",
            "Fire",
            "Water",
            "Lightning",
            "Psychic",
            "Fighting",
            "Darkness",
            "Metal",
            "Dragon",
            "Colorless",
            "Fairy"
          ],

          renderOption:
            renderEnergyTypeOption
        },


        /* ======================================================
           RARITY
        ====================================================== */

        {
          key: "rarity",
          field: "rarity",
          label: "Rarity",
          split: false,
          order: [
            "Common",
            "Uncommon",
            "Rare",
            "Double Rare",
            "Ultra Rare",
            "Illustration Rare",
            "Special Illustration Rare",
            "Mega Hyper Rare"
          ],

          renderOption:
            renderRarityOption
        },


        /* ======================================================
           STAGE
        ====================================================== */

        {
          key: "stage",
          field: "stage",
          label: "Stage",
          split: false,

          options: [
            "Basic",
            "Stage 1",
            "Stage 2",
            "VSTAR",
            "VMAX",
            "BREAK",
            "LEGEND"
          ]
        },


        /* ======================================================
           SUBTYPE
        ====================================================== */

        {
          key: "subtype",
          field: "subtypes",
          label: "Subtype",

          separator:
            /,\s*/,

          control:
            "search-multiselect",

          placeholder:
            "Search or select a subtype...",

          emptyText:
            "No matching subtypes",

          initialSuggestions:
            8,

          maxSuggestions:
            50,

          filterOptions: function (
            value,
            instance
          ) {
            var subtype =
              normalizeLower(value);

            /*
              Pokémon stages have their own dedicated
              filter, so normally don't duplicate them
              under Subtype.
            */
            var stageValues = [
              "basic",
              "stage 1",
              "stage 2"
            ];

            /*
              "Basic" can also legitimately describe
              Basic Energy.

              In that case expose Basic in Subtype
              when Energy is selected.
            */
            if (subtype === "basic") {
              return instance
                .getFilterValues(
                  "supertype"
                )
                .some(
                  function (category) {
                    return (
                      normalizeLower(
                        category
                      ) ===
                      "energy"
                    );
                  }
                );
            }

            return (
              stageValues.indexOf(
                subtype
              ) === -1
            );
          }
        },


        /* ======================================================
           EVOLVES FROM
        ====================================================== */

        {
          key: "evolves_from",
          field: "evolves_from",
          label: "Evolves From",
          split: false,

          control:
            "search-multiselect",

          placeholder:
            "Search or select a Pokémon...",

          emptyText:
            "No matching Pokémon",

          initialSuggestions:
            8,

          maxSuggestions:
            50
        }
      ],

      renderer: {
        renderGridCard:
          renderPokemonGridCard,

        renderListCard:
          renderPokemonListCard,

        updateCardVariant:
          updatePokemonCardVariant
      }
    });  

      /*
      Use Pokémon's cleaned card name for shared
      name searching and A-Z sorting.
    */
    registeredInstance.getCardTitle =
      function (card) {
        var selected =
          this.getSelectedVariant(card) ||
          (
            card &&
            Array.isArray(card.variants)
              ? card.variants[0]
              : null
          ) ||
          {};

        return getPokemonTitleParts(
          selected
        ).name;
      };


    /*
      Initialize the current shared-grid instance.

      Collection pages use the shared collection loader.

      Search pages initialize the controls first, then
      install their embedded search rows.
    */
    registeredInstance
      .initialize()
      .then(function (instance) {

        if (isSearchPage) {
          return instance;
        }

        /*
          Pokémon collection-to-collection navigation
          also uses the current shared navigation engine.

          The collection Liquid supplies:
            data-json-url
            data-product-count
            data-default-sort

          and adjacent-set links use:
            data-singles-collection-link
        */
        if (
          typeof api.createCollectionNavigation ===
          "function"
        ) {
          collectionNavigation =
            api.createCollectionNavigation({
              root:
                instance.root,

              rootSelector:
                "[data-singles-collection][data-game=\"pokemon\"]",

              linkSelector:
                "[data-singles-collection-link]",

              gridInstance:
                instance,

              preserveSortOnLinks:
                true,

              reloadOnSort:
                true,

              fallbackOnError:
                true
            });
        }

        console.log(
          "Pokemon collection rows loaded:",
          instance.state.rows.length
        );

        console.log(
          "Pokemon collection products grouped:",
          instance.state.cards.length
        );

        return instance;
      })
      .catch(function (error) {
        console.error(
          "Pokemon grid initialization failed:",
          error
        );
      });


    /*
      Small Pokémon-facing API.

      This is intentionally much thinner than the old
      adapter. Shared singles behavior stays inside
      SinglesGrid.
    */
    window.PokemonGrid = {

      getInstance: function () {
        return registeredInstance;
      },

      getCollectionNavigation:
        function () {
          return collectionNavigation;
        },

      render: function (rows) {
        if (!registeredInstance) {
          return;
        }

        registeredInstance.setRows(
          Array.isArray(rows)
            ? rows.slice()
            : []
        );

        registeredInstance.setLoading(
          false
        );
      },

      getState: function () {
        return registeredInstance
          ? registeredInstance.state
          : null;
      }
    };


    return registeredInstance;
  }


  // =========================================================
  // STARTUP
  // =========================================================

  function initialize() {
    var instance =
      registerPokemonGrid();

    if (
      !instance &&
      document.readyState !==
        "loading"
    ) {
      console.error(
        "Pokemon grid could not start because js-theme-singles-grid.js was not loaded first."
      );
    }
  }


  /*
    Normally both files are deferred and the shared
    grid loads first.

    Keep the ready-event fallback so Pokémon can also
    recover if script timing changes later.
  */
  if (
    window.SinglesGrid &&
    window.SinglesGrid.version
  ) {
    initialize();

  } else {
    document.addEventListener(
      "singles:grid:ready",
      initialize,
      {
        once: true
      }
    );

    if (
      document.readyState ===
      "loading"
    ) {
      document.addEventListener(
        "DOMContentLoaded",
        initialize,
        {
          once: true
        }
      );

    } else {
      window.setTimeout(
        initialize,
        0
      );
    }
  }

})(window, document);  